<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%"
          src="../../../static/img/solutions/artificialintelligence/banner.png"
          alt="#"
        />
      </Col>
      <Col span="24" class="ContactUs_1">
        <div class="box_1">
          <div
            class="box1"
            @click="switching(1)"
            :class="{ active: isSHOW == 1 }"
          >
            <div class="box_font">
              <div>行业现状</div>
              <div>
                <img
                  v-if="isSHOW == 1"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="box2"
            @click="switching(2)"
            :class="{ active: isSHOW == 2 }"
          >
            <div class="box_font">
              <div>政策支持</div>
              <div>
                <img
                  v-if="isSHOW == 2"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="box3"
            @click="switching(3)"
            :class="{ active: isSHOW == 3 }"
          >
            <div class="box_font">
              <div>解决方案</div>
              <div>
                <img
                  v-if="isSHOW == 3"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="box_2">
          <div class="box_3">
            <div style="margin-top: 20px">
              <div style="font-size: 20px">工地安全事故频发</div>
              <div>未佩戴安全防护用品，管理缺失</div>
            </div>
            <div style="margin-top: 20px">
              <div style="font-size: 20px">行业监管日趋严格</div>
              <div>多地出台规定，全方位监管</div>
            </div>
            <div style="margin-top: 20px">
              <div style="font-size: 20px">用人成本不断提高</div>
              <div>老龄化严重，急需数字化降本</div>
            </div>
            <div style="margin-top: 20px">
              <div style="font-size: 20px">现场巡检效率过低</div>
              <div>工地分布散，路途耗时多</div>
            </div>
            <div style="margin-top: 20px">
              <div style="font-size: 20px">项目问题发现滞后</div>
              <div>风险漏报多，事后处理损失重</div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_2"></Col>
      <Col span="24" class="ContactUs_4"></Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      isSHOW: 1,
    };
  },
  mounted() {},
  methods: {
    switching(item) {
      this.isSHOW = item;
    },
  },
};
</script>

<style scoped>
.ContactUs_1 {
  height: 700px;
  background-color: #f7f8fa;
  display: flex;
}

.box_font {
  width: 170px;
  height: 46px;
  font-family: SourceHanSansCNRegular;
  /* font-weight: 700; */
  font-size: 26px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  float: right;
  display: flex;
  margin-right: 70px;
}

.box_1 {
  width: 45%;
  margin-top: -5px;
  background-color: #1b2e64;
}

.box1 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box2 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box3 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box_2 {
  width: 55%;
  background-image: url("../../../static/img/solutions/artificialintelligence/Earth.png");
  background-size: 100% 100%;
  margin-top: -5px;
}

.ContactUs_2 {
  height: 960px;
  background-image: url("../../../static/img/solutions/artificialintelligence/three.png");
  background-size: 100% 100%;
}

.ContactUs_3 {
  text-align: center;
  margin-top: 66px;
}

.ContactUs_4 {
  height: 608px;
  background-image: url("../../../static/img/solutions/artificialintelligence/four.png");
  background-size: 100% 100%;
}

.LunContent {
  background: #ffffff;
}

.LunContent img {
  width: 100%;
  height: 900px;
}

.active {
  border-bottom: 3px solid #6d91f7;
}

.box_3 {
  width: 279px;
  height: 424px;
  background: rgba(13, 28, 71, 0.8);
  border-radius: 4px 4px 4px 4px;
  margin: 118px 0 0 36px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  color: #ffffff;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/solutions/artificialintelligence.vue